class SubscriptionsController implements ng.IComponentController {
    constructor() {
        'ngInject';
    }
}

export const subscriptionsComponent : ng.IComponentOptions = {
    controller : SubscriptionsController,
    template :require('./subscriptions.html')
}


// WEBPACK FOOTER //
// ./src/app/modules/subscriptions/subscriptions.component.ts